/* src/modules/discounts/cards/ViewOwnerCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, isEqual, map, startCase } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  IconButton,
  Menu, MenuItem,
  Modal,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { MoreHoriz, MoreVert } from '@material-ui/icons';

import CreateOwner from '../../components/CreateOwner';

import { HeaderTable, PaperHeader } from '../../../../app/components';
import styles from './styles';

import { getSelected } from '../../selectors';
import { modifyActiveDiscount, modifyDiscountHolder } from '../../actions';
import { onError } from '../../../app_state/actions';

class ViewOwnerCard extends React.Component {
  state = {
    anchorEl: null,
    ownerAnchorEl: null,
    discount: null,
    openEdit: false,
  }

  discountOptions = ['change active status']
  ownerOptions = ['edit']

  _onClickSave = async () => {
    const { ownerName, ownerEmail, ownerPhone, chosenUniversities } = this._createOwner.getInfo();
    const { selected } = this.props;
    if (!ownerName || isEmpty(chosenUniversities)) {
      this.props.onError({ message: 'name and universities cannot be empty' });
      return;
    }
    const update = {};
    if (ownerName !== selected.name) update.name = ownerName;
    if (ownerEmail !== selected.email) update.email = ownerEmail;
    if (ownerPhone !== selected.phone) update.phone = ownerPhone;
    if (!isEqual(chosenUniversities, map(selected.universities, '_id')))
      update.universities = chosenUniversities;

    if (!isEmpty(update)) {
      update._id = selected._id;
      await this.props.modifyDiscountHolder({ discountHolderUpdateInput: update });
    }
    this.setState({ openEdit: false });
  };

  _onSelectChangeActiveStatus = async () => {
    const { discount } = this.state;
    await this.props.modifyActiveDiscount({
      discount: discount._id,
      active: discount.active !== 'Yes',
    });
    this.props.fetchOwners();
    this.setState({ anchorEl: null });
  }

  _onSelectEdit = () => {
    this.setState({ openEdit: true, ownerAnchorEl: null });
  }

  _onCloseEdit = () => {
    this.setState({ openEdit: false });
  }

  _onCloseMenuDiscount = () => {
    this.setState({ anchorEl: null });
  }

  _onCloseMenuOwner = () => {
    this.setState({ ownerAnchorEl: null });
  }

  _onMoreActions = discount => event => {
    this.setState({ anchorEl: event.currentTarget, discount });
  }

  _onClickOwnerAction = event => {
    this.setState({ ownerAnchorEl: event.currentTarget });
  }

  renderMoreActions = datum => (
    <IconButton onClick={this._onMoreActions(datum)}>
      <MoreHoriz />
    </IconButton>
  );

  renderSelectedMenu = (anchorEl, type) => (
    <Menu
      id={`${type}-menu`}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={this[`_onCloseMenu${startCase(type)}`]}
    >
      {this[`${type}Options`].map(l => (
        <MenuItem
          key={l}
          onClick={this[`_onSelect${startCase(l).replace(/ /g, '')}`]}
        >
          {startCase(l)}
        </MenuItem>
      ))}
    </Menu>
  );

  renderEditOwner = () => {
    const { classes, selected } = this.props;
    const { openEdit } = this.state;
    return (
      <Modal
        aria-labelledby="edit_owner"
        aria-describedby="Edit Discount Owner"
        open={openEdit}
        onClose={this._onCloseEdit}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {`Edit ${selected.name}`}
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.createOwnerContent}>
            <CreateOwner
              innerRef={node => this._createOwner = node}
              ownerName={selected.name}
              ownerEmail={selected.email}
              ownerPhone={selected.phone}
              organization={selected.organization}
              universities={selected.universityChoices}
              chosenUniversities={map(selected.universities, '_id')}
            />
            <div className={classes.space} />
            <Divider />
            <div className={classes.buttonContainer}>
              <Button color="primary" className={classes.saveButton} onClick={this._onClickSave}>
                {'Save'}
              </Button>
              <Button color="secondary" onClick={this._onCloseEdit}>
                {'Cancel'}
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
    );
  };

  render() {
    const { classes, selected } = this.props;
    const { anchorEl, ownerAnchorEl } = this.state;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text={selected.name}>
          <IconButton onClick={this._onClickOwnerAction}>
            <MoreVert />
          </IconButton>
        </PaperHeader>
        <Typography className={classes.emailPhoneText}>
          {`${selected.email} | ${selected.phone}`}
        </Typography>
        <HeaderTable
          data={selected.discounts}
          Action={this.renderMoreActions}
        />
        {this.renderSelectedMenu(anchorEl, 'discount')}
        {this.renderSelectedMenu(ownerAnchorEl, 'owner')}
        {this.renderEditOwner()}
      </Paper>
    );
  }
}

ViewOwnerCard.propTypes = {
  classes: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  modifyActiveDiscount: PropTypes.func.isRequired,
  fetchOwners: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  modifyDiscountHolder: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selected: getSelected(state),
});

const mapDispatchToProps = dispatch => ({
  modifyActiveDiscount: params => dispatch(modifyActiveDiscount(params)()),
  modifyDiscountHolder: params => dispatch(modifyDiscountHolder(params)()),
  onError: params => dispatch(onError(params)),
});

export default compose(
  withStyles(styles, { name: 'ViewOwnerCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(ViewOwnerCard);



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/ViewOwnerCard/index.js